import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../utilities/classNames";

var GroupItem = function GroupItem(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(GroupItem.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

GroupItem.displayName = "GroupItem";
/* eslint-disable max-len */

GroupItem.propTypes = {
  /**
   * Component or element to be grouped
   */
  children: PropTypes.node.isRequired
};
/* eslint-enable max-len */

export default GroupItem;